export default "__VITE_ASSET__ffc7770f__"